export const GET_SESSION_FAMILIES = "GET_SESSION_FAMILIES";
export const GET_SESSION_FAMILIE_BY_ID = "GET_SESSION_FAMILIE_BY_ID";
export const UPDATE_SESSION_FAMILIE = "UPDATE_SESSION_FAMILIE";
export const DELETE_SESSION_FAMILIE = "DELETE_SESSION_FAMILIE";
export const CREATE_SESSION_FAMILIE = "CREATE_SESSION_FAMILIE";
